<template>
  <div id="age-gate-container">
    <div class="age-gate-body">
      <div class="width-container">
        <div class="logo-container">
          <img :src="mhllogoImage" alt />
        </div>
        <div class="form-container">
          <div class="subtitle">
            <h2>
              Miller High Life nació
              <br> en 1903 y tú?
            </h2>
          </div>
          <div class="form-row" :class="showWarning ? 'hasError' : '' ">
            <input
              ref="day"
              type="text"
              maxlength="2"
              placeholder="DD"
              v-on:keyup="focusNextSibling($event)"
              v-model="day"
            />
            <input
              ref="month"
              type="text"
              maxlength="2"
              placeholder="MM"
              v-on:keyup="focusNextSibling($event)"
              v-model="month"
            />
            <input
              ref="year"
              type="text"
              maxlength="4"
              placeholder="YYYY"
              v-on:keyup="focusNextSibling($event)"
              v-model="year"
            />
            <input type="submit" text="enviar" class="submit-button" @click="normalLogin($event)" />
          </div>
          <div class="AgeGate-warning-connect" v-if="!showWarning">
            <div class="AgeGate-warning-wrapper">
              <p class="AgeGate-warning-message">También puedes acceder usando una <br> red social o creando tu cuenta:</p>
            </div>
          </div>
          <FacebookButton
            v-if="!showWarning"
            v-on:fbLogin="fbLogin"
            v-on:noBirthdayInFacebook="noBirthdayInFacebook"
            isForResponsive="desktop"
          />
          <FacebookButton
            v-if="!showWarning"
            v-on:fbLogin="fbLogin"
            v-on:noBirthdayInFacebook="noBirthdayInFacebook"
            isForResponsive="mobile"
          />
          <div class="AgeGate-warning" v-if="showWarning">
            <div class="AgeGate-warning-wrapper">
              <p class="AgeGate-warning-message">Debes ser mayor de edad para navegar este sitio</p>
            </div>
          </div>
          <div class="AgeGate-warning" v-if="false">
            <div class="AgeGate-warning-wrapper">
              <p
                class="AgeGate-warning-message"
              >Debes ser mayor de edad para navegar y tu edad es privada en facebook</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="age-gate-footer">
      <div class="logo-in-footer">
        <img :src="mhlcenteredlogoImage" alt="" class="footer-logo">
      </div>
      <div class="footer-titles">
        <div class="privacy-container">
          <h4 class="privacy"
            @click="$router.push('/tycos')">términos y condiciones</h4>
          <h4 class="privacy bar">|</h4>
          <h4 class="privacy"
            @click="$router.push('/politics')">política de privacidad</h4>
          <h4 class="privacy bar">|</h4>
          <h4 class="privacy"
            @click="$router.push('/cookies')">política de cookies</h4>
          <h4 class="privacy bar">|</h4>
          <h4 class="privacy desktop nohover">evita el exceso - producto para mayores de 18 años</h4>
          <h4 class="privacy mobile nohover">
            evita el exceso
            <br>producto para mayores de 18 años
          </h4>
        </div>

        <div class="footer-subtitle">
          <p>© 2020 Coors Brewing Co. Y ™/® Propiedad de Coors Brewing Company, Denver, CO USA.</p>
        </div>
      </div>
      <div class="number-in-footer">
        <a href="tel:8002378392" @click="onClickOptionsPush()">
          <img alt="contact" :src="phonenumberImage" class="footer-logo" />
        </a>
        <!--<img :src="phonenumberImage" alt="" class="footer-logo">-->
      </div>
    </div>
    <Modal 
      v-if="showModal"
      v-bind:wichModal="wichModal"
      @close="showModal = false"/>
  </div>
</template>

<script>
import Moment from "moment";
import axios from 'axios';

import mhllogo from "@/assets/miller-high-life-logo.png";
import mhlphrase from "@/assets/miller-high-logo-phrase.png";
import mhlcenteredlogo from "@/assets/miller-high-life-centered-logo.png";
import phonenumber from "@/assets/800CERVEZA.png";

import { mapActions } from "vuex";
import { mapGetters } from "vuex";

import Modal from '@/components/Modal'
import FacebookButton from '@/components/FacebookButton'
import {differenceInYears, format, parse, isValid} from 'date-fns'
//Implementar tag
import tagFunctions from '../utils/tagFunctions';

export default {
  name: "AgeGate",
  components: {
    FacebookButton,
    Modal
  },
  data() {
    return {
      day: undefined,
      month: undefined,
      year: undefined,
      showWarning: false,
      mhllogoImage: mhllogo,
      mhlphraseImage: mhlphrase,
      mhlcenteredlogoImage: mhlcenteredlogo,
      phonenumberImage: phonenumber,
      showModal: false,
      wichModal: 'terms',
      response: null,
      refererPath: '',
      refererParams: '',
    };
  },
  computed: {
    ...mapGetters([""])
  },
  methods: {
    ...mapActions({
      setAgeGateTokenAction: "setAgeGateToken"
    }),
    //Implementar tag Click over options
    onClickOptionsPush() {
      tagFunctions.evClickOptionsPush("click_to_call")
    },
    //Implementar tag Age Gate Events
    attemptAgeGate(){
      tagFunctions.evAgeGatePush('Intento')
    },
    passAgeGate(){
      tagFunctions.evAgeGatePush('Exito')
    },
    failAgeGate(errorMessage){
      tagFunctions.evAgeGatePush('Error', errorMessage)
    },
    noBirthdayInFacebook() {
      this.showWarning = true;
    },
    // fbLogin(response) {
    //   this.attemptAgeGate()
    //   //const bDay = parse(`${response.birthday}`,'MM/dd/yyyy', new Date())
    //   //const today = new Date()
    //   //const age = differenceInYears(today, bDay)
    //   const minAge = response.age_range.min
    //   //window.sessionStorage.setItem('ageUser', age)
    //   //window.sessionStorage.setItem('ageUserBirthYear', format(bDay, 'yy'))
    //   window.sessionStorage.setItem("ageUser", minAge);
    //   window.sessionStorage.setItem("ageUserBirthYear", minAge);
    //   //if (isNaN(age) || age < 18) {
    //   if (isNaN(minAge) || minAge < 18) {
    //     //console.log("🚀 ~ fbLogin ~ minAge:", minAge)
    //     this.showWarning = true;
    //     this.failAgeGate('El usuario es menor de edad')
    //   } else {
    //     setTimeout(() => {
    //       axios
    //         .get(
    //           `https://cuamoc.xeerpa.com:8443/discoveruser?clientId=57a058bdee4dc3d82f06fffa&clientPwd=qwbd3udgh2diksKcsG&appId=5def8589787d690d08439f86&socialNetwork=FB&userId=${response.authResponse.userID}&userToken=${response.authResponse.accessToken}`
    //         )
    //         .then((axiosResponse) => {
    //           this.response = axiosResponse;
    //           setTimeout(() => {
    //             this.setAgeGateTokenAction(true);
    //             window.sessionStorage.setItem('ageGateToken', true)
    //             window.sessionStorage.setItem('login_type', 'Facebook')
    //             window.sessionStorage.setItem('network', 'Facebook')
    //             this.passAgeGate()
    //             //console.log("setAgeGateTokenAction");
    //           }, 200);
    //         })
    //         .catch((e) => {
    //           this.errors.push(e);
    //         });
    //     }, 100);
    //   }
    //   //if (Number.isNaN(age) || age < 18) {
    //    // this.showWarning = true;
    //   //} else {
    //     //setTimeout(() => {
    //       //axios
    //           //.get(
    //           //  `https://cuamoc.xeerpa.com:8443/discoveruser?clientId=57a058bdee4dc3d82f06fffa&clientPwd=qwbd3udgh2diksKcsG&socialNetwork=FB&appId=5def8589787d690d08439f86&userId=${response.authResponse.userID}&userToken=${response.authResponse.accessToken}`
    //           //)
    //           //.then(axiosResponse => {
    //           //  setTimeout(() => {
    //           //    this.setAgeGateTokenAction(true);
    //           //  }, 200)
    //           //})
    //           //.catch(e => {
    //           //  this.errors.push(e);
    //           //(())});
    //     //}, 100);
    //     //this.setAgeGateTokenAction(true);
    //     //setTimeout(() => {
    //        // this.setAgeGateTokenAction(true);
    //      // }, 100);
    // },
    fbLogin() {},
    parseFlexibleDate(rawDate) {
      const formats = ['dd/MM/yyyy', 'MM/dd/yyyy', 'yyyy/MM/dd', 'yyyy/dd/MM', 'yyyy-MM-dd', 'yyyy-dd-MM', 'dd-MM-yyyy', 'MM-dd-yyyy' ];
      for (const formatStr of formats) {
        const parsed = parse(rawDate, formatStr, new Date());
        if (isValid(parsed)) {
          return parsed;
        }
      }
      const fallback = new Date(rawDate);
      return isValid(fallback) ? fallback : null;
    },
    xeerpaLogin() {
      this.attemptAgeGate()
      // Obtener el parámetro 't' desde la URL
      const paramT  = this.$route.query.t;
      localStorage.setItem('t', paramT);
      if(paramT!= null) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("t", paramT);

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

      fetch("https://login.heinekenmexico.com/api/connect/getUserData", requestOptions)
        .then(response => {
          // Primero, verifica si la respuesta de la red fue exitosa
          if (!response.ok) {
            // Si la respuesta no es OK (ej. 404, 500), lanza un error para que el bloque .catch lo maneje.
            throw new Error(`Error de red: ${response.status}`);
          }
          // Si la respuesta es exitosa, la convertimos a JSON.
          // Esto devuelve una promesa que resuelve con el objeto JSON parseado.
          return response.json();
        })
        .then(result => {
          //console.log("Objeto JSON completo:", result);
          // Si necesitas guardar todo el objeto en localStorage como JSON:
          localStorage.setItem('data', JSON.stringify(result));
          const social = result.data.sn;
          const location = result.data.formData.location;
          const rawBirthday = result.data.formData.birthday;
          //console.log("birthday (crudo):", rawBirthday);
          // Acceder a la propiedad 'birthday' dentro de 'data' y 'formData'
          const bDay = this.parseFlexibleDate(rawBirthday);
          if (!bDay) {
            //console.error("No se pudo interpretar la fecha:", rawBirthday);
            this.showWarning = true;
            this.failAgeGate('Formato de fecha inválido');
            return;
          }
          //console.log("Fecha de cumpleaños (parseada):", bDay);
          const today = new Date()
          const age = differenceInYears(today, bDay)
          window.sessionStorage.setItem('ageUser', age)
          window.sessionStorage.setItem('ageUserBirthYear', format(bDay, 'yyyy'))
          window.sessionStorage.setItem('ageUserCountry', location)
          if (isNaN(age) || age < 18) {
            this.showWarning = true;
            this.failAgeGate('El usuario es menor de edad')
          } else {
            setTimeout(() => {
              document.cookie = `agegate_miller_goldenritual=${format(bDay, "dd-MM-yyyy")}; path=/; secure`;
              this.setAgeGateTokenAction(true);
              window.sessionStorage.setItem('ageGateToken', true)
              window.sessionStorage.setItem('login_type', social)
              window.sessionStorage.setItem('network', social)
              this.passAgeGate()
              //Redirigir al subsitio si hay refererPath
              if (this.refererPath) {
                window.location.href = location.origin + this.refererPath;
              } else {
                // Si no hay referer, ir al home
                window.location.href = location.origin;
              }
            }, 200);
          } 
        })
        .catch(error => console.log('Hubo un error en la petición o al procesar los datos:', error));
      }
    },
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    hideWarning() {
      this.showWarning = false;
    },
    normalLogin(event) {
      this.attemptAgeGate()
      const { day, month, year } = this;
      if (day && day !== "" && month && month !== "" && year && year !== "") {
        //const bDay = Moment(`${day}/${month}/${year}`, "DD/MM/YYYY");
        const bDay = parse(`${day}/${month}/${year}`, "dd/MM/yyyy", new Date());
        //const today = Moment();
        const today = new Date()
        const ageYear = Number(format(bDay,"yyyy")) > Number(format(today,"yyyy"));
        //const age = today.diff(bDay, "years");
        const age = differenceInYears(today, bDay)
        window.sessionStorage.setItem('ageUser', age)
        window.sessionStorage.setItem('ageUserBirthYear', format(bDay,'yy'))
        if (isNaN(age) || age < 18) {
          this.showWarning = true;
          this.failAgeGate('El usuario es menor de edad')
        } else {
          setTimeout(() => {
            document.cookie = `agegate_miller_goldenritual=${format(bDay, "dd-MM-yyyy")}; path=/; secure`;
            this.setAgeGateTokenAction(true);
            window.sessionStorage.setItem('ageGateToken', true)
            window.sessionStorage.setItem('login_type', 'Age')
            window.sessionStorage.setItem('network','Normal')
            this.passAgeGate()
            //Redirigir al subsitio si hay refererPath
            if (this.refererPath) {
              window.location.href = location.origin + this.refererPath;
            } else {
              // Si no hay referer, ir al home
              window.location.href = location.origin;
            }
          }, 100);
        }
      }
    },
    focusNextSibling(event) {
      const element = event.target;
      if (
        element &&
        element.value &&
        element.value.length === event.target.maxLength
      ) {
        event.target.nextElementSibling.focus();
      }
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const refererPath = urlParams.get('refererPath') || '';
    const refererParams = urlParams.get('refererParams') || '';
    this.refererPath = refererPath;
    this.refererParams = refererParams;

    this.$nextTick(() => {});
    this.xeerpaLogin();
    this.$router.beforeEach((to, from, next) => {
      //console.log('q', to)
      if(to.path == '/politics' || to.path == '/cookies' || to.path == '/tycos'){
        next()
        this.setAgeGateTokenAction(true);
        location.reload()
      }
      next()
    })
  }
};
</script>

<style lang="scss">
@import "~@/styles/agegate.scss";
</style>
